import styled from 'styled-components/macro'

import { IconBoard } from '@loadsmart/icons'
import { BannerLarge, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const StyledOl = styled.ol`
  li {
    list-style: decimal;
    list-style-position: inside;
  }

  li::marker {
    color: ${getToken('color-neutral-dark')};
  }
`

export function BulkSpotQuoteInstructionsBanner() {
  return (
    <BannerLarge
      variant="success"
      title="Send your rates in two steps"
      description={
        <StyledOl type="1">
          <li>
            <Text>
              <strong>Insert your desired rate</strong> for the lane
            </Text>
          </li>
          <li>
            <Text>
              <strong>Click on submit</strong> to send the filled up rates. You can return later
              until the deadline to finish all the lanes if you'd like
            </Text>
          </li>
        </StyledOl>
      }
      icon={<IconBoard width={18} />}
    />
  )
}
